import React, { useEffect, useRef, useState ,useMemo} from 'react';
import moment from 'moment';
import './bearer-token.scss';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicHiddenInput,
  DynamicCheckBoxInput
} from '../software-dynamic-version-7/mainSection-multiple-inputs-v-7';
import DropdownService from '../software-dynamic-version-7/api.service-v-7';


const BearerTokenAdd = (props) => {
  let {
    DynamicDropDownInput: DropdownComponent,
    DynamicNumericInput: NumberComponent,
    DynamicDateInput: DateComponent,
    DynamicTextInput: TextComponent,
    DynamicHiddenInput: HiddenComponent,
    DynamicCheckBoxInput:CheckBoxComponent
  } = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput, DynamicTextInput, DynamicHiddenInput ,DynamicCheckBoxInput};

  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = { ...updatedValues[key], ...valueObj[key] };
        }
      });
      return updatedValues;
    });
  };


const [inputProps, setInputProps] = useState({
  CompanyID: { name: 'CompanyID', value: props.CompanyID || undefined },

  CompanyName: { name: 'CompanyName', value: props.CompanyName || '', caption: 'Company Name',enabled:false },

  CompanyNTNCNIC: {
    name: 'CompanyNTNCNIC',
    value: props.CompanyNTNCNIC || '',
    caption: 'NTN / CNIC',
    enabled:false
  },

  BearerToken: { name: 'BearerToken', value: props.BearerToken || '', caption: 'Bearer Token' },
  BearerTokenForTesting: {
    name: 'BearerTokenForTesting',
    value: props.BearerTokenForTesting || '',
    caption: 'Bearer Token (Testing)',
    enabled:false
  },

});

useEffect(()=>{
  
},[])
  const handleInputCreated = async (e, name) => {

    if(name == 'BearerToken'){
      if(document.getElementById('BearerToken')){
        document.getElementById('BearerToken').focus()
        document.getElementById('BearerToken').select()
        
      }
    }
   
  };
const handleInputBlur = async  (value, name) => {   
  };
 
const handleInputChange = async  (value, name) => {   
  console.log(name)
  console.log(value)
  
  };
 
  
  // ==================== Main Inputs ====================
 const inputsList = [
  { Input: HiddenComponent, Props: { ...inputProps.CompanyID, setInputProps }, ColumnSize: 0 },

  { Input: TextComponent, Props: { ...inputProps.CompanyName, setInputProps }, ColumnSize: 6 },
  

  { Input: TextComponent, Props: { ...inputProps.CompanyNTNCNIC, setInputProps }, ColumnSize: 6 },
  
  { Input: TextComponent, Props: { ...inputProps.BearerToken, setInputProps ,onCreated:handleInputCreated}, ColumnSize: 6 },
  { Input: TextComponent, Props: { ...inputProps.BearerTokenForTesting, setInputProps }, ColumnSize: 6 },

];

  
    
  return (
    <div onKeyDown={(e) =>{ 
      if (e.key === 'Escape') {
        console.log('ESC pressed');
        // your logic here
        e.stopPropagation()
      }
      e.stopPropagation()
      }}>

      <StructuredGenerate mainProps={props} title={`${props.Title} ${props.isAdd === true ? ` - Add` : ` - Edit`}`} Inputs={inputsList} />

      <br />

    </div>
  );
};

export default BearerTokenAdd;
